/* La stampa da vicino. Lo script della sezione sections/bh-lente.liquid, caricato solo da lei.
   1. la foto del dettaglio e i tre ritagli si chiedono quando la sezione è a 600 px dallo schermo, mai prima; la foto più grande per il
      vetro solo al primo gesto sulla lente (fino ad allora il vetro ingrandisce la foto già arrivata);
   2. la lente si trascina col dito e col mouse, col mouse segue anche il puntatore; un tocco sulla foto la porta lì;
   3. con la tastiera la foto prende il fuoco e le frecce muovono la lente;
   4. un tocco su un ritaglio (x1, x2, x4) fa saltare la lente al suo centro e le dà l'ingrandimento del ritaglio, col bollino che lo dice
      (X-TELEFONO 18/10/2026, B-MOBILE §2.6: prima la lente restava a x3 e x2 e x4 davano la stessa vista); con «riduci movimento» il salto
      è senza animazione.
   Nessuna libreria. */
(function () {
  'use strict';
  var Z = 3, ZZ = [1, 2, 4];
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function avvia(box) {
    if (box.getAttribute('data-bh-lente-vivo')) return;
    box.setAttribute('data-bh-lente-vivo', '1');
    var foto = box.querySelector('.bh-lente__foto');
    var img = foto && foto.querySelector('img');
    var vetro = foto && foto.querySelector('.bh-lente__vetro');
    if (!foto || !img || !vetro) return;
    var pos = { x: parseFloat(box.getAttribute('data-x')) || 0.5, y: parseFloat(box.getAttribute('data-y')) || 0.5 };
    var z = Z;
    vetro.setAttribute('data-z', z);
    var grande = box.getAttribute('data-grande'), caricate = false, nitida = false, tieni = false, tm = 0;

    function metti() {
      var w = foto.clientWidth, h = foto.clientHeight;
      if (!w || !h) return;
      var r = vetro.offsetWidth / 2, x = pos.x * w, y = pos.y * h;
      vetro.style.left = (pos.x * 100) + '%';
      vetro.style.top = (pos.y * 100) + '%';
      vetro.style.backgroundSize = Math.round(w * z) + 'px ' + Math.round(h * z) + 'px';
      vetro.style.backgroundPosition = Math.round(r - x * z) + 'px ' + Math.round(r - y * z) + 'px';
    }
    function carica() {
      if (caricate) return;
      caricate = true;
      box.querySelectorAll('img[data-src]').forEach(function (i) {
        if (i.getAttribute('data-srcset')) i.setAttribute('srcset', i.getAttribute('data-srcset'));
        i.setAttribute('src', i.getAttribute('data-src'));
        i.removeAttribute('data-src');
        i.removeAttribute('data-srcset');
      });
      // il vetro usa la foto della pagina finché non arriva quella grande
      function base() { if (!nitida && (img.currentSrc || img.src)) vetro.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")'; metti(); }
      if (img.complete && img.naturalWidth) base(); else img.addEventListener('load', base);
      metti();
    }
    var chiesta = false;
    function nitidaOra() {
      carica();
      if (chiesta || !grande) return;
      chiesta = true;
      var g = new Image();
      g.onload = function () { nitida = true; vetro.style.backgroundImage = 'url("' + grande + '")'; };
      g.src = grande;
    }
    function salta(x, y) {
      if (!quieto) {
        box.classList.add('bh-lente--salta');
        clearTimeout(tm);
        tm = setTimeout(function () { box.classList.remove('bh-lente--salta'); }, 300);
      }
      pos.x = Math.min(1, Math.max(0, x));
      pos.y = Math.min(1, Math.max(0, y));
      metti();
    }
    function da(e) {
      var r = foto.getBoundingClientRect();
      if (!r.width || !r.height) return;
      pos.x = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
      pos.y = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
      metti();
    }

    vetro.addEventListener('pointerdown', function (e) {
      tieni = true;
      box.classList.add('bh-lente--tieni');
      try { vetro.setPointerCapture(e.pointerId); } catch (x) {}
      nitidaOra();
      e.preventDefault();
    });
    vetro.addEventListener('pointermove', function (e) { if (tieni) da(e); });
    function lascia() { tieni = false; box.classList.remove('bh-lente--tieni'); }
    vetro.addEventListener('pointerup', lascia);
    vetro.addEventListener('pointercancel', lascia);
    foto.addEventListener('click', function (e) { if (e.target !== vetro) { nitidaOra(); salta((e.clientX - foto.getBoundingClientRect().left) / foto.clientWidth, (e.clientY - foto.getBoundingClientRect().top) / foto.clientHeight); } });
    foto.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse' && !tieni) { nitidaOra(); da(e); } });
    foto.addEventListener('keydown', function (e) {
      var k = { ArrowLeft: [-0.04, 0], ArrowRight: [0.04, 0], ArrowUp: [0, -0.04], ArrowDown: [0, 0.04] }[e.key];
      if (!k) return;
      nitidaOra();
      pos.x = Math.min(1, Math.max(0, pos.x + k[0]));
      pos.y = Math.min(1, Math.max(0, pos.y + k[1]));
      metti();
      e.preventDefault();
    });
    var ritagli = box.querySelectorAll('.bh-lente__ritaglio');
    ritagli.forEach(function (b, i) {
      b.addEventListener('click', function () {
        nitidaOra();
        z = parseFloat(b.getAttribute('data-z')) || ZZ[i] || Z;
        vetro.setAttribute('data-z', z);
        ritagli.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        salta(parseFloat(b.getAttribute('data-x')), parseFloat(b.getAttribute('data-y')));
      });
    });
    var larga = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== larga) { larga = window.innerWidth; metti(); } });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (v) {
        if (v[0].isIntersecting) { io.disconnect(); carica(); }
      }, { rootMargin: '600px 0px' });
      io.observe(box);
    } else {
      carica();
    }
  }

  document.querySelectorAll('[data-bh-lente]').forEach(avvia);
})();
